import { render, staticRenderFns } from "./PublicationProgress.vue?vue&type=template&id=57c59172&scoped=true&"
import script from "./PublicationProgress.vue?vue&type=script&lang=js&"
export * from "./PublicationProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c59172",
  null
  
)

export default component.exports